const Placement = {
  TOP: 'top',
  BOTTOM_LEFT: 'bottomleft',
  RIGHT: 'right',
};
export default Placement;
